<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h3 class="text-bold">Shipments</h3>
      </div>
      <div class="grid-body">
        <vue-good-table
          mode="remote"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          :totalRows="totalRecords"
          styleClass="table table-bordered"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
          }"
          :row-style-class="trafficLightSystem"
          :columns="columns"
          :rows="shipments"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'created_at'" class="text-bold">
              <router-link
                :to="{ path: '/shirt/shipment/detail/' + props.row.id }"
              >
                {{ formatDate(props.row.created_at) }}
              </router-link>
            </span>
            <span v-else-if="props.column.field == 'eta'">
              <span v-if="props.row.shipper">{{
                formatDate(props.row.eta)
              }}</span>
            </span>
            <span v-else-if="props.column.field == 'id'">
              <router-link
                :to="{ path: '/shirt/shipment/detail/' + props.row.id }"
                class="btn btn-primary"
                v-if="!isReadOnlyUser"
                >Edit</router-link
              >
              <button
                class="btn btn-success"
                @click="showModalbox(props.row.id)"
                v-if="!isReadOnlyUser"
              >
                Add / View Components
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <!-- modal for adding component boxes -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title text-bold">Add Components</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-white">
            <div class="container-fluid">
              <table class="table table-bordered">
                <thead>
                  <tr class="add-comp-header">
                    <th>
                      <button
                        class="btn btn-success"
                        @click="addComponentRow()"
                      >
                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                      </button>
                      Item Name
                    </th>
                    <th>Amount</th>
                    <th>Carton</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(component, index) in components"
                    :key="component.id"
                  >
                    <ShipmentComponentDetail
                      :component="component"
                      :deleteComponentRow="deleteComponentRow"
                      :index="index"
                      :items="items"
                      @reload="reloadItemList"
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="addComponents()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal for adding component boxes -->
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import ShipmentComponentDetail from "./components/shipmentComponentDetail";
export default {
  components: {
    ShipmentComponentDetail,
    VueGoodTable,
  },
  data() {
    return {
      shipments: [],
      isReadOnlyUser: false,
      columns: [
        {
          label: "Date",
          field: "created_at",
          tdClass: "text-left",
          thClass: "text-left",
          sortable: false,
        },
        {
          label: "Flight Number",
          field: "flight_no",
          tdClass: "text-left",
          thClass: "text-left",
          sortable: false,
        },
        {
          label: "ESTIMATE TIME OF ARRIVAL",
          field: "eta",
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
        },
        {
          label: "AWB TRACKING NUMBER",
          field: "awb",
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
        },
        {
          label: "Shipper",
          field: "shipper",
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
        },
        {
          label: "",
          field: "id",
          tdClass: "text-right",
          thClass: "text-right",
          sortable: false,
        },
      ],
      selectedShipmentId: null,
      components: [],
      items: [],
      serverParams: {
        page: 1,
        perPage: 10,
      },
      totalRecords: 0,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.fetchItemsOptions();
    this.getShipments();
  },
  methods: {
    async fetchItemsOptions() {
      try {
        let { data: res } = await axios.get("v2/others/accessory_item");
        this.items = res.data
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((item) => item.name);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    reloadItemList(event) {
      console.log("reloadItemList");
      this.fetchItemsOptions();
    },

    async getShipments() {
      try {
        let res = await axios.get("packaging/shipments", {
          params: this.serverParams,
        });
        this.totalRecords = res.data.total;
        this.shipments = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },

    addComponentRow() {
      this.components.push({
        id: new Date().getTime(),
        name: null,
        total: 0,
        carton: 0,
      });
    },

    deleteComponentRow(index) {
      this.components.splice(index, 1);
    },

    showModalbox(id) {
      this.getComponents(id);
      show_modal("#modal-box");
      this.selectedShipmentId = id;
    },

    async getComponents(id) {
      this.components = [];

      try {
        let res = await axios.get("packaging/shipment/get_components/" + id);
        let components = res.data.sort((a, b) => (a.name < b.name ? -1 : 1));
        if (components.length < 1) {
          this.addComponentRow();
        } else {
          this.components = components;
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async addComponents() {
      let result = await Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios.post(
            "packaging/shipment/add_components/" + this.selectedShipmentId,
            { components: this.components }
          );
          if (res.data.success) {
            toastr.success("SUCCESS");
            hide_modal("#modal-box");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getShipments();
    },

    onPerPageChange(params) {
      this.updateParams({ page: 1, perPage: params.currentPerPage });
      this.getShipments();
    },
    trafficLightSystem(row) {
      const flightDetails =
        row.airline && row.awb && row.flight_no && row.shipper;
      return !flightDetails
        ? "traffic-red"
        : flightDetails && !row.shipment_completed
        ? "traffic-yellow"
        : flightDetails && row.shipment_completed
        ? "traffic-green"
        : "";
    },
  },
};
</script>
<style>
.table-success {
  background: #09a699;
  color: white;
}
.modal-header .close {
  margin-top: -20px !important;
}
.traffic-red {
  background-color: rgb(255 0 0 / 20%);
}
.traffic-yellow {
  background-color: rgb(255 255 0 / 20%);
}
.traffic-green {
  background-color: rgb(0 128 0 / 20%);
}
.add-comp-header .btn {
  margin-right: 10px;
}
</style>
